module.exports = __webpack_public_path__ + "img/Gefahr_durch_Mineralöl.e9fc50d6.svg";